import { useMemo } from 'react';
import { RouterProvider, createBrowserRouter, useRouteError } from 'react-router-dom';
import { useFlowContext } from '../context/FlowContext';
import { useConfigContext } from '../context/ConfigContext';
import { pages } from '../PageConfig';
import CustomErrorPage from '../pages/ErrorPage';
import { PageComponentWrapper } from '../pages/PageComponentWrapper';
import Root from './Root';
import { ProductPage } from '../interfaces/interfaces';
import RMOPage from '../pages/RMOPage';
import { ErrorResponse } from '@remix-run/router';

function ErrorBoundary() {
    const error: Pick<ErrorResponse, 'status' | 'statusText'> = useRouteError() as ErrorResponse;
    return <CustomErrorPage error={error} />;
}

function AppRouter() {
    const config = useConfigContext();
    const productPages = pages[config.product];
    const { flow } = useFlowContext();

    const children = useMemo(
        () =>
            productPages.map((item: ProductPage) => {
                const Component = item.component;
                return {
                    path: item.path,
                    element: (
                        <PageComponentWrapper
                            title={item.title}
                            size={item.size}
                            titleStyle={item.titleStyle}
                            wrapperChildren={
                                <Component
                                    pageKey={item.key}
                                    flow={flow}
                                    onLoadFn={item.onLoadFn}
                                    boxTitle={item.boxTitle}
                                    validateFields={item.validateFields}
                                />
                            }
                        />
                    ),
                    children: item.children
                };
            }),
        [flow, productPages]
    );

    const router = useMemo(
        () =>
            createBrowserRouter(
                [
                    {
                        element: <Root />,
                        errorElement: <ErrorBoundary />,
                        children: (children as any) || []
                    },
                    {
                        path: '/ring-mig-op',
                        element: <RMOPage />
                    }
                ],
                {
                    basename: config.appBasePath
                }
            ),
        [config.appBasePath, children]
    );

    return <RouterProvider router={router} />;
}

export default AppRouter;
